import { Ref } from "vue"
import IGlobalData from "@/models/GlobalData"
import shaka from "shaka-player"
import injectStrict from "@/utils/injectStrict"
import { LoggerKey } from "@/symbols"
export default function setUp(
  video: Ref<HTMLVideoElement | undefined>,
  globalData: IGlobalData
) {
  var player: typeof shaka.Player
  let logger = injectStrict(LoggerKey)
  async function loadPlayer() {
    await shaka.polyfill.installAll()
    player = new shaka.Player(video.value)
    // For more Shaka Player options, see: https://github.com/google/shaka-player
    player.configure({
      abr: {
        defaultBandwidthEstimate: 16000000 // 2 MB/s or 1.6e+7 bits/s
      },
      playRangeStart: parseFloat(globalData.time_data.startTime ?? "0"),
      playRangeEnd: parseFloat(globalData.time_data.endTime ?? "Infinity"),
      streaming: {
        jumpLargeGaps: true,
        bufferingGoal: 20,
        retryParameters: {
          maxAttempts: 5
        },
        failureCallback: (err: any) => {
          logger?.error(`Video Buffering failed::${err}`)
        }
      }
    })
  }
  async function loadhls(hls_url: string, continuefromTime: number = 0) {
    await loadPlayer()
    player
      .load(hls_url)
      .then(() => {
        if (continuefromTime > 0) {
          video.value!.currentTime = continuefromTime
          video.value!.play()
        }
      })
      .catch(async (error: any) => {
        if (/InvalidStateError/i.test(error)) {
          logger?.warn(
            "Parmonic Widget Warning: State Error occured reloading video"
          )
          await loadhls(hls_url)
          return
        } else {
          logger?.error(
            `Parmonic Widget Error: Loading hls url failed: ${error}`
          )
        }
      })
  }
  async function loaddash(dash_url: string) {
    await loadPlayer()
    try {
      await player.load(dash_url)
    } catch (error: any) {
      if (/InvalidStateError/i.test(error)) {
        logger?.warn(
          "Parmonic Widget Warning: State Error occured reloading video "
        )
        await loaddash(dash_url)
        return
      } else {
        logger?.error(
          `Parmonic Widget Error: Loading dash url failed: ${error}`
        )
      }
    }
  }
  async function detachShakaPlayer() {
    await player.detach()
  }

  return { loadhls, loaddash, detachShakaPlayer }
}
